import { Component, Input, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { DataService } from '../../../services/data.service';
import { ShortEncryptorService } from '../../../services/short-encryptor.service';
import emailjs from '@emailjs/browser';
import { DemoFormComponent } from '../../demos/demo-form/demo-form.component';
import { ViewKycComponent } from '../../demos/view-kyc/view-kyc.component';


@Component({
	selector: 'app-demo-list',
	imports: [CommonModule, FormsModule, DemoFormComponent, ViewKycComponent],
  providers: [DatePipe],
	templateUrl: './demo-list.component.html',
	styleUrl: './demo-list.component.scss',
})
export class DemoListComponent {
	@Input() action: any;

  datePipe = inject(DatePipe);
	base = 'demo';		// important for API calls
  btnClick: string = "";
  loading = false;
  isEdit = false;
	allData: any = [];
	demoData: any = null;
  selUser: any = null;
  urType: string = '';    // 'Pending', 'Rejected', 'Converted' Subscriber who wanted to become paid user from trial user
	statusBadge: Record<string, string> = {
    "New": "bg-warning",
    "Contacted": "bg-success",
    "Pending": "bg-info",
    "Follow Up": "bg-info",
    "Demo Scheduled": "bg-success",
    "Interested": "bg-success",
    "Rejected": "bg-danger",
    "Converted": "bg-success",
    "Closed": "bg-dark"
  };

  constructor(private auth: AuthService, public dataService: DataService, private shCrypt: ShortEncryptorService) {
    //
  }

  ngOnInit() {
    /*
    const originalWord = 'trial';

    // Generate multiple completely different encryption strings for the same keyword
    const codeA = this.shCrypt.encrypt(originalWord);
    const codeB = this.shCrypt.encrypt(originalWord);

    console.log('Encrypted Variant A:', codeA); // Output example: "b3f7k2"
    console.log('Encrypted Variant B:', codeB); // Output example: "x9w2m8"

    // Decrypting both unique variations produces the exact same root content
    const decryptedA = this.shCrypt.decrypt(codeA);
    const decryptedB = this.shCrypt.decrypt(codeB);

    console.log('Decrypted Result A:', decryptedA); // "pizza"
    console.log('Decrypted Result B:', decryptedB); // "pizza"
    */

    this.loading = true;
    this.dataService.getAllRecords(this.base).then((res: any) => {
      this.allData = res;
      this.loading = false;
    });
	}

	ngOnChanges() {
		if(this.action && this.action=='reload') {
			this.ngOnInit();
		}
	}

  newClick() {
    this.isEdit = false;
    this.btnClick = 'addnew';
    this.dataService.updateOuterAction({
      component: 'demo',
      action: 'addnew', data: null
    });
  }

  editClick(myData: any) {
    this.isEdit = true;
    this.btnClick = 'modify';
    this.dataService.updateOuterAction({
      component: 'demo',
      action: 'edit', data: myData
    });
  }

  statusClick(demoData: any, newStatus: string) {
    this.loading = true;
		const myid = this.demoData.id;
		delete this.demoData.id;
    this.demoData.status = newStatus;
    this.demoData.address = '';
    this.demoData.city = '';
    this.demoData.state = '';
    this.demoData.pincode = '';
    if(newStatus == 'Invalid') {
      this.demoData.is_active = 'false';
    }

    this.dataService.updateRecord(this.base, myid, this.demoData).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
        this.ngOnInit();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

  /*
  setupTrialSW(demoData: any) {
    const customCode = this.shCrypt.encrypt('trial');
    const curDate: Date = new Date();
    const expDate: Date = this.dataService.getFutureDate(curDate, 8);

    const userData: any = {
      id: null, 
      erp_key: '',
      display_name: demoData.full_name, 
      user_name: customCode, 
      password_hash: '123', 
      user_role: [{"code":"adm","name":"User Admin"}],
      cur_date: this.datePipe.transform(curDate, 'yyyy-MM-dd'), 
      is_active: true
    };

    this.dataService.addNewRecord('users', userData).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.sendEmail(demoData.email_id);
        this.loading = false;
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

  sendEmail(emailTo: string) {
    emailjs.send(
      'service_5ak8cck',
      'template_7wn7isx', {
        email: emailTo
      },
      'oL3_6kGTB0jKdmSUW'
    )
    .then(() => {
      console.log('Email Sent at '+emailTo);
    })
    .catch(error => {
      console.error(error);
    });
  }
  */

  setupNewAccount(demoData: any) {
    this.selUser = demoData;
  }

  reloadData() {
    setTimeout(()=>{
      this.ngOnInit();
    }, 1000);
  }

	async deleteClick(myid: number) {
    const confirmed = await this.dataService.confirmDelete();
    if (confirmed) {
        console.log('Item deleted successfully');
				this.doDelete(myid);
    } else {
        console.log('Deletion cancelled');
    }
	}

  doDelete(myid: number) {
		this.loading = true;
    this.dataService.deleteRecord(this.base, myid).subscribe({
      next: (response) => {
        console.log('Response received in component:', response);
        // You can handle your loading states or form resets here:
        this.loading = false;
        this.ngOnInit();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
	}
}
